import React from "react"
import PropTypes from 'prop-types'
import resolveProps from '../../../utils/resolveProps'
import clearProps from '../../../utils/clearProps'

export default class Row extends React.Component {
  constructor(props) {
    super(props);

    this.config = {
      types : [],
      modifiers : [],
      states : []
    }

  }

  render() {
    const { children, ...rest } = this.props
    const props = clearProps(this.props)
    return <div {...props} className={resolveProps(this.props, this.config, 'Row')}>
        {children}
    </div>
  }
}

Row.propTypes = {
  children : PropTypes.node
}